module.exports = {
    title: "开盖有礼_惠合科技数字营销方案_精准营销、灵活落地",
    description: "依托瓶盖，可叠加丰富奖励形式，促进C端营销活动灵活落地。",
    keywords: "开盖有礼,揭盖有奖,UTC活动,消费者营销,一品一码,商品溯源"
}